import {
  IconShieldCheck,
  IconCrown,
  IconUserStar,
  IconUserCheck,
  IconEye,
} from "@tabler/icons-react";
import styles from "../../pages/ClientDashboard/TeamManagement/teamManagement.module.css";

const PERMISSIONS = [
  {
    icon: IconCrown,
    bg: "#fef3c7",
    fg: "#92400e",
    name: "Admin",
    desc: "Full access — settings, billing, all data",
  },
  {
    icon: IconUserStar,
    bg: "#eff2ff",
    fg: "#3b5fe8",
    name: "Manager",
    desc: "Manage jobs, talents, and team members",
  },
  {
    icon: IconUserCheck,
    bg: "#f0fdf4",
    fg: "#166534",
    name: "Member",
    desc: "View and collaborate on assigned tasks",
  },
  {
    icon: IconEye,
    bg: "var(--bg)",
    fg: "var(--text-muted)",
    name: "Viewer",
    desc: "Read-only access to shared content",
  },
];

export default function RolePermissionsCard() {
  return (
    <div className={styles.sidebarCard}>
      <div className={styles.sidebarCardHeader}>
        <IconShieldCheck size={17} />
        <span className={styles.sidebarCardTitle}>Role Permissions</span>
      </div>
      <div
        className={`${styles.sidebarCardBody} ${styles.sidebarCardBodyPerm}`}
      >
        {PERMISSIONS.map(({ icon: Icon, bg, fg, name, desc }) => (
          <div className={styles.permItem} key={name}>
            <div
              className={styles.permIcon}
              style={{ background: bg, color: fg }}
            >
              <Icon size={14} />
            </div>
            <div>
              <div className={styles.permName}>{name}</div>
              <div className={styles.permDesc}>{desc}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
